import './utils/extensions';
import './utils/ajax';
import './utils/colors';
import './utils/common';
import './utils/convert-functions';
import './utils/cookie-helpers';
import './utils/dates';
import './utils/html-query-url';
import './utils/rebind-data-source';
import './utils/toastr-utils';
import './utils/validation';
import './modules/back-multiselect';
import './modules/back-places-service';
import './modules/dynamic-audit-history';
import './modules/expand-collapse-buttons';
import './modules/filters';
import './modules/kanban';
import './modules/kendo';
import './modules/kendo-combobox';
import './modules/kendo-datepicker';
import './modules/kendo-editor';
import './modules/kendo-grid';
import './modules/kendo-grid-colors';
import './modules/kendo-multiselect';
import './modules/kendo-scheduler';
import './modules/kendo-textbox';
import './modules/kendo-tree-list';
import './modules/lazy-audio';
import './modules/local-comments';
import './modules/model';
import './modules/pipeline';
import './modules/toastr';
import './modules/yandex-map';
import { Gallery } from './modules/gallery';
import { TableValidator } from './modules/table-validator';

window.Gallery = Gallery;
window.TableValidator = TableValidator;

$.ajaxSetup({ 'X-Timezone': -(new Date().getTimezoneOffset() / 60) } as unknown as JQueryAjaxSettings);

kendo.culture('ru-RU');

document.body.onkeydown = (e) => {
    const code = (e.keyCode || e.which);
    if ($('.filters ')[0] && !$('.dict-editor').is(':visible')) {
        /**
         * 'Enter' keydown
         * */
        if (code === 13) {
            e.preventDefault();
            $(':focus').blur();
            window.btFilter_onClick?.();
        }
    }

    // Ctrl + Key
    if (e.ctrlKey && !e.shiftKey && !e.altKey) {
        /**
         * 'S' keydown
         * */
        if (code === 83) {
            e.preventDefault();
            window.btSave_onClick?.();
        }
        /**
         * 'Q' keydown
         * */
        if (code === 81) {
            window.wndTicket_createWindow?.();
        }
    }
};

document.onkeydown = ({ ctrlKey, key }) => {
    if (
        $('#btToggleFilters').length === 1
        && $('.filters').length === 1
        && ctrlKey
        && (key === '.' || key === '/')
    ) {
        $('#btToggleFilters')[0].click();
    }
};

$(() => {
    window.updateTimeZone();
    window.installToastr();
    window.loadModel();
    window.setFirst(true);

    const grid = window.findFirstGrid();
    if (grid) {
        window.setFilters(grid, !window.isNeedFirstGridLoad);
        window.setSettingsGrid(grid);
    }

    window.datePeriodOnChange();

    if (localStorage.getItem(`${location.pathname} -showFilters`) || location.href.indexOf('showFilters') !== -1) {
        const btElem = $('#btToggleFilters');
        if (btElem.length === 1) btElem[0].click();
    }

    if (location.pathname.search(/\d+/g) === -1) {
        window.recollectFiltersOnSourceChange();
    }

    if (location.search && grid && window.btLoadAutosums_onClick) {
        grid.dataSource.one('change', () => {
            window.btLoadAutosums_onClick?.();
        });
    }

    window.validationMessageTmpl = kendo.template($('#validationMessage').html());
    window.floatingButtonsAutoTop();
    window.updateTimeZone();
    window.initKendoGrid();
    window.setProperIframeResize();
    window.bindResizeHeightMultiSelect();
    window.setControlsSettings();
    window.setColorsTdYesNo();
});

$(window).on('resize', () => {
    window.floatingButtonsAutoTop();

    window.findFirstGrid()?.element[0].classList.add('fix-width-table');
    window.adjustGridHeight();
    window.adjustSchedulerHeight();
});